<template>
  <div>
    <transition name="slide-right">
      <div
        v-if="showSidebarLeft"
        class="layout-headerSidebar_nav">
        <div
          class="layout-headerSidebar_navBg"
          @click="toggleSidebarLeft"></div>
        <div class="layout-headerSidebar_navContainer">

          <div class="layout-headerSidebar_navHeader">
            <button
              class="layout-header_button--menuClose"
              @click="toggleSidebarLeft">
              <span class="menu-text">CLOSE</span>
            </button>
          </div>
          <div class="layout-headerSidebar_navBody">

            <nav class="layout-header_nav">
              <ul>
                <li>
                  <router-link :to="{ name: 'PageIndex' }">Top</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'PageAbout' }">About</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'PageSkills' }">Skills</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'PageWorks' }">Works</router-link>
                </li>
                <li>
                  <router-link  class="link--contact" :to="{ name: 'PageContact' }">Contact me</router-link>
                </li>
              </ul>
            </nav>

          </div>

          <div class="layout-headerSidebar_navSns">

            <header-nav-sns />

          </div>

        </div>
      </div>
    </transition>

    <div class="header-inner">
      <button
        class="layout-header_button--menu"
        @click="toggleSidebarLeft">
        <span class="menu-icon"></span>
        <span class="menu-text">MENU</span>
      </button>
    </div>
  </div>
</template>

<script>
import HeaderNavSns from "./HeaderNavSns";

export default {
  components: {
    HeaderNavSns
  },
  data() {
    return {
      showSidebarLeft: false
    };
  },
  destroyed() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.remove("menu-opened");
  },
  methods: {
    toggleSidebarLeft() {
      this.showSidebarLeft = !this.showSidebarLeft;

      let body = document.getElementsByTagName("body")[0];
      if(this.showSidebarLeft) {
        body.classList.add("menu-opened");
      } else {
        body.classList.remove("menu-opened");
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layouts/default/HeaderSp.vue